import {
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormHelperText, // Import FormHelperText for validation error message
  } from "@mui/material";
  import { useState } from "react";
  import { useDispatch } from "react-redux";
  import { addDealerToShift } from "store/slice/shiftsSlice";
  
  const AddMissedDealersModal = ({
    openAddignModal,
    handleModalClose,
    studios,
    shiftDate,
    dealerId,
  }) => {
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [selectedStudio, setSelectedStudio] = useState("");
    const [selectedShift, setSelectedShift] = useState("1");
    const [studioError, setStudioError] = useState(""); // To track validation error
    const dispatch = useDispatch();
  
    const closeModal = () => {
      handleModalClose();
    };
  
    const handleSubmit = () => {
      // Basic validation for the studio selection
      if (!selectedStudio) {
        setStudioError("Please select a studio.");
        return;
      }
  
      // If validation passes, dispatch the action
      dispatch(
        addDealerToShift({
          selectedStudio,
          selectedShift,
          shiftDate,
          dealerId,
        })
      );
  
      handleModalClose(); // Close the modal after submission
    };
  
    return (
      <Dialog 
        open={openAddignModal} 
        onClose={closeModal} 
        fullWidth 
        maxWidth="sm"
        sx={{zIndex: 999999}}
      >
        <DialogTitle>Assign Dealer to Studio</DialogTitle>
        <DialogContent>
          <FormControl
            fullWidth
            margin="normal"
            error={Boolean(studioError)} // Add error prop to highlight the error state
          >
            <InputLabel>Select Studio</InputLabel>
            <Select
              value={selectedStudio}
              onChange={(e) => {
                setSelectedStudio(e.target.value);
                setStudioError(""); // Clear error when the user selects a studio
              }}
              label="Select Studio"
              sx={{ padding: "0 1rem", zIndex: 9999999 }}
              MenuProps={{
                disablePortal: true,
                PaperProps: {
                  sx: {
                    zIndex: 9999999, // Just higher than Dialog default zIndex (1300)
                  },
                },
              }}
            >
              {studios.map((studio) => (
                <MenuItem key={studio.id} value={studio.id} sx={{ minHeight: 48 }}>
                  {studio.name}
                </MenuItem>
              ))}
            </Select>
            {studioError && <FormHelperText>{studioError}</FormHelperText>} {/* Show error message */}
          </FormControl>
  
          <FormControl component="fieldset" margin="normal">
            <Typography variant="subtitle1">Select Shift Type</Typography>
            <RadioGroup
              value={selectedShift}
              onChange={(e) => setSelectedShift(e.target.value)}
            >
              <FormControlLabel value="1" control={<Radio />} label="Morning" />
              <FormControlLabel value="2" control={<Radio />} label="Night" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default AddMissedDealersModal;
  